module.exports = __webpack_public_path__ + "static/no-company-image-153041c5fc8829bccf58691403f06e8d.png";